import { ReceivingLogTableConfig } from '../../../../../../models/assets-data/receiving/ReceivingLogTableConfig.interface';


/**
 * Default receiving log table configuration used as a fallback if fetching the receiving-log-table-config.json assets file fails.
 * 
 * - Defines table structure, input fields, validation rules, and display settings.
 * - Ensures key fields like Vendor, Job Details, PO Number, and Storage Facility are properly configured.
 * - Supports different input types (text, number, date, textarea, select).
 * - Some fields are disabled to prevent modification (e.g., Date In, Logged By).
 * 
 * This ensures the receiving log table remains operational even without dynamic configuration retrieval.
 */
export const DEFAULT_ASSETS_RECEIVING_LOG_TABLE: ReceivingLogTableConfig = {
  receivingLogTable: {
  tableName: "Receiving Log",
    inputs: [
      {
        name: "vendor",
        label: "Vendor",
        formFieldType: "input",
        disabled: true,
        showOnCard: true
      },
      {
        name: "jobNumber",
        label: "Job Number",
        formFieldType: "input",
        disabled: true,
        cardTitleRight: true
      },
      {
        name: "jobName",
        label: "Job Name",
        formFieldType: "input",
        disabled: true
      },
      {
        name: "jcDept",
        label: "JC Dept",
        formFieldType: "input",
        disabled: true
      },
      {
        name: "poNumber",
        label: "PO Number",
        formFieldType: "input",
        disabled: true,
        cardTitle: true,
        sortable: true
      },
      {
        name: "items",
        label: "Items",
        formFieldType: "textarea",
        required: true,
        showOnCard: true
      },
      {
        name: "email",
        label: "Email",
        formFieldType: "input",
        inputType: "text"
      },
      {
        name: "quantity",
        label: "Quantity",
        formFieldType: "input",
        required: true
      },
      {
        name: "location",
        label: "Shelf Location",
        formFieldType: "input",
        showOnCard: true
      },
      {
        name: "dateIn",
        label: "Date In",
        formFieldType: "date",
        placeholder: "MM/DD/YY",
        disabled: true,
        showOnCard: true,
        sortable: true
      },
      {
        name: "dateOut",
        label: "Date Out",
        formFieldType: "date",
        placeholder: "MM/DD/YY",
        sortable: true
      },
      {
        name: "takenBy",
        label: "Taken By",
        formFieldType: "input"
      },
      {
        name: "shopFloorSF",
        label: "Shop SF",
        formFieldType: "input",
        inputType: "number"
      },
      {
        name: "loggedBy",
        label: "Logged By",
        formFieldType: "input",
        disabled: true
      },
      {
        name: "notes",
        label: "Notes",
        formFieldType: "textarea"
      },
      {
        name: "storageFacility",
        label: "Storage Facility",
        formFieldType: "select"
      }
    ]
  }
  };
  